@if (languageChanged) {
	<div class="report-language-changed">
		{{ 'insights.report.languageChanged' | translate }}
		<button mat-flat-button color="primary" (click)="languageChanged = false">
			{{ 'general.hideMessage' | translate }}
		</button>
	</div>
}
@if (!noReportSelected && !extUrlReportSelected) {
	<powerbi-report [eventHandlers]="reportEventHandlers" [cssClassName]="reportCssClassName" [embedConfig]="reportConfig"></powerbi-report>
}
@if (!noReportSelected && extUrlReportSelected) {
	<div class="ext-resource powerbi-embed-class" id="container">
		<iframe frameborder="0" [src]="safeUrl(reportConfig.embedUrl)" allowfullscreen></iframe>
	</div>
}
@if ((!noReportSelected || extUrlReportSelected) && !sidenavService.isPhone()) {
	<mat-icon mat-icon class="report-fullscreen-icon" svgIcon="acies_embed_fullscreen" (click)="toggleFullscreen(extUrlReportSelected)"></mat-icon>
}
@if (noReportSelected) {
	<p>{{ 'insights.report.notSelected' | translate }}</p>
}
